document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#deliveries-chart");
  if (chartEl && window.ApexCharts) {
    const params = new URLSearchParams(window.location.search);

    fetch(`/reports/deliveries.json?${params.toString()}`)
      .then(response => response.json())
      .then(data => {
        const categories = data.map(item => item.date);
        const serviceData = data.map(item => item.service_cost);
        const transportationData = data.map(item => item.transportation_cost);

        const options = {
          series: [
            { name: "Service Cost (Charged)", data: serviceData },
            { name: "Transportation Cost (Internal)", data: transportationData }
          ],
          chart: { height: 300, type: "line", toolbar: { show: false } },
          colors: ["#0d6efd", "#ffc107"], // blue for service, amber for transportation
          dataLabels: { enabled: false },
          stroke: { curve: "smooth" },
          xaxis: { categories: categories },
          tooltip: { x: { format: "dd MMM yyyy" } }
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading deliveries chart data:", error));
  }
});
